import styled from 'styled-components';

const S = {};

S.Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 5;
  
  &.floating-mode {
    position: static;
  }
`;

S.StreamIcon = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  
  svg {
    width: 100%;
    height: 100%;
  }
  
  &:hover {
    opacity: 0.8;
  }
`;

S.PlayerWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #000;
  border-radius: 8px;
  overflow: hidden;
  
  &.floating {
    position: fixed;
    top: auto;
    left: auto;
    bottom: 20px;
    right: 20px;
    width: 400px;
    height: auto;
    aspect-ratio: 16/9;
    z-index: 9999;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
  }
`;

S.PlayerHost = styled.div`
  width: 100%;
  height: 100%;
  background: #000;
  position: relative;
  
  /* Upewnij się że wideo wypełnia cały kontener */
  & > div {
    width: 100% !important;
    height: 100% !important;
  }
  
  video {
    width: 100% !important;
    height: 100% !important;
    object-fit: contain;
  }
`;

S.ErrorBar = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  background: rgba(27, 27, 27, 0.95);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  z-index: 10;
`;

S.ErrorMessage = styled.div`
  color: #fff;
  font-size: 14px;
  flex: 1;
`;

S.PlayerControls = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  gap: 6px;
  z-index: 10;
`;

S.ControlButton = styled.button`
  background: rgba(0, 0, 0, 0.7);
  border: none;
  color: #fff;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  
  &:hover {
    background: rgba(0, 0, 0, 0.9);
  }
  
  svg {
    width: 16px;
    height: 16px;
    fill: currentColor;
  }
`;

S.LoadingOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
`;

export default S;
